/* Generated file. Do not modify. Please check more details in build/generate.ts */
import * as React from "react";
import type { IconProps } from "../IconTypes";
import { IconWrapper } from "../IconWrapper";
export function ListCollapseIcon(props: IconProps) {
    return (<IconWrapper {...props}>
            {<>
                    <path d="M29.554 24.336a1.5 1.5 0 0 1 2.007.103l4 4 .103.115a1.5 1.5 0 0 1-2.11 2.11l-.114-.104-2.94-2.939-2.94 2.94a1.5 1.5 0 1 1-2.12-2.122l4-4z"/>
                    <path d="M25.44 8.44a1.5 1.5 0 0 1 2.12 0l2.94 2.939 2.94-2.94.114-.103a1.5 1.5 0 0 1 2.11 2.11l-.103.114-4 4a1.5 1.5 0 0 1-2.007.104l-.114-.104-4-4a1.5 1.5 0 0 1 0-2.12"/>
                    <path d="M5 9.5A1.5 1.5 0 0 1 6.5 8h14a1.5 1.5 0 0 1 0 3h-14A1.5 1.5 0 0 1 5 9.5"/>
                    <path d="M5 19.5A1.5 1.5 0 0 1 6.5 18h14a1.5 1.5 0 0 1 0 3h-14A1.5 1.5 0 0 1 5 19.5"/>
                    <path d="M5 29.5A1.5 1.5 0 0 1 6.5 28h14a1.5 1.5 0 0 1 0 3h-14A1.5 1.5 0 0 1 5 29.5"/>
                </>}
        </IconWrapper>);
}
